<template>
  <div>
    <b-card class="div-card">
      <b-card-body>
        <h2>Página não encontrada. Clique em <b-link @click="redirect()">Home</b-link> para ser redirecionado.</h2>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'NotFoundPage',
  data() {
    return {};
  },
  methods: {
    redirect(){
      this.$router.push("home");
    }
  }
};
</script>

<style scoped>
.div-card {
  border-radius: 0px;
  border: 1px solid transparent;
  margin: 12px;
  -webkit-box-shadow: 1px 0px 7px rgba(50, 50, 50, 0.87);
  -moz-box-shadow: 1px 0px 7px rgba(50, 50, 50, 0.87);
  box-shadow: 1px 0px 7px rgba(50, 50, 50, 0.87);
}
</style>



// WEBPACK FOOTER //
// src/components/notfoundpage/NotFoundPage.vue